/* eslint-disable react/prop-types */
import React, { useLayoutEffect, useState } from 'react'
import { createTheme } from '@material-ui/core/styles'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles'
import { readCssVar } from '../../app/util/resolveThemeColor'

/** Fallbacks match `:root` in `_augmentt-theme-colors-light.scss` when CSS is not loaded yet */
const FALLBACK_PALETTE = {
  primaryMain: '#3399FF',
  secondaryMain: '#0abb87',
  secondaryContrastText: '#ffffff',
  errorMain: '#fd397a',
}

function createAppMuiTheme() {
  const primaryMain = readCssVar('--aug-product-blue', FALLBACK_PALETTE.primaryMain)
  const secondaryMain = readCssVar('--aug-mui-legacy-secondary', FALLBACK_PALETTE.secondaryMain)
  const secondaryContrastText = readCssVar('--aug-text-on-inverse', FALLBACK_PALETTE.secondaryContrastText)
  const errorMain = readCssVar('--bs-danger', FALLBACK_PALETTE.errorMain)

  // Explicit contrastText avoids MUI dev warnings: augmentColor() only calls getContrastText when contrastText is missing.
  return createTheme({
    typography: {
      fontFamily: ['Sofia Pro'].join(','),
    },
    palette: {
      contrastThreshold: 2,
      primary: {
        main: primaryMain,
        contrastText: '#ffffff',
      },
      secondary: {
        main: secondaryMain,
        contrastText: secondaryContrastText,
      },
      error: {
        main: errorMain,
        contrastText: '#ffffff',
      },
      warning: {
        main: '#ff9800',
        contrastText: 'rgba(0, 0, 0, 0.87)',
      },
      info: {
        main: '#2196f3',
        contrastText: '#ffffff',
      },
      success: {
        main: '#4caf50',
        contrastText: 'rgba(0, 0, 0, 0.87)',
      },
    },
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiPopover: {
        elevation: 1,
      },
    },
  })
}

export default function ThemeProvider(props) {
  const { children } = props
  const [muiTheme, setMuiTheme] = useState(() => createAppMuiTheme())

  useLayoutEffect(() => {
    setMuiTheme(createAppMuiTheme())
  }, [])

  return <MuiThemeProvider theme={muiTheme}>{children}</MuiThemeProvider>
}
